export default "__VITE_ASSET__d8c0eb0d__"